// ══════════════════════════════════════════════════════════════
// COMPASS – Country Reducer
// ══════════════════════════════════════════════════════════════
import { createReducer, on } from '@ngrx/store';
import { CountryActions } from './country.actions';
import { initialCountryState, CountryState } from './country.state';

export const countryReducer = createReducer<CountryState>(
  initialCountryState,

  // Already loaded: the effect skips the request, so don't flag a load.
  on(CountryActions.loadCountries, (state): CountryState => ({
    ...state,
    loading: !state.loaded,
    error: null,
  })),

  // Keeps the current list on screen until the localized one arrives.
  on(CountryActions.reloadCountries, (state): CountryState => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(CountryActions.loadCountriesSuccess, (state, { countries }): CountryState => ({
    ...state,
    countries,
    loading: false,
    loaded: true,
    error: null,
  })),

  on(CountryActions.loadCountriesFailure, (state, { error }): CountryState => ({
    ...state,
    loading: false,
    error,
  })),
);
